window.addEventListener("load", function () {
    const loadMore = document.getElementById('insightful-load-more-magazines');
    const appendMagazines = document.getElementById('insightful-magazine-append');

    if (loadMore && appendMagazines) {
        let skip = 5;
        const pageId = loadMore.dataset.pageId;

        loadMore.addEventListener('click', async function () {
            // Fetch Magazines
            const response = await fetch(`/umbraco/surface/InsightfulHomepageSurface/LoadMoreMagazines?pageId=${pageId}&skip=${skip}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })

            if (response.ok) {
                const data = await response.json();

                // Build HTML from data and insert in the HTML document
                if (data && data.magazines && data.magazines.length) {
                    data.magazines.forEach((magazine) => {
                        let magazineHtml = document.createElement("a");
                        let imageDiv = document.createElement("div");
                        let textDiv = document.createElement("div");

                        magazineHtml.setAttribute("href", magazine.url);
                        magazineHtml.classList.add("edition")

                        imageDiv.classList.add("edition__thumbnail");
                        textDiv.classList.add("edition__content");

                        if (magazine.imageUrl) {
                            let image = document.createElement("img");
                            image.setAttribute("src", magazine.imageUrl);
                            image.setAttribute("alt", magazine.imageName);

                            imageDiv.append(image);
                        }

                        let year = document.createElement("date");
                        let title = document.createElement("h3");
                        let subtitle = document.createElement("p");

                        year.innerHTML = magazine.year;
                        title.innerHTML = magazine.title;
                        subtitle.innerHTML = magazine.subtitle;

                        textDiv.append(year);
                        textDiv.append(title);
                        textDiv.append(subtitle);

                        magazineHtml.append(imageDiv);
                        magazineHtml.append(textDiv);

                        appendMagazines.append(magazineHtml);
                    })

                    if (data.lastItems) {
                        loadMore.classList.add('hidden');
                    }
                    else {
                        skip += 4;
                    }
                }
            }
        });
    }
});
